export default __webpack_public_path__ + "static/media/vr-headset.6f54af26.svg";